export function ProductSectionTitle({ title }: { readonly title: string }) {
  return (
    <div className="flex flex-row items-center justify-center gap-sm w-full">
      <span className="border-b-2 border-lightGray flex-1"></span>
      <h2 className="text-silver text-center">{title}</h2>
      <span className="border-b-2 border-lightGray flex-1"></span>
    </div>
  );
}
